export const COMPANY = {
  name: "Agroya Refinery LLP",
  short: "Agroya",
  tagline: "Refining Purity. Building Trust.",
  location: "Pune, Maharashtra, India",
  phone: "+91 72109 95999",
  whatsapp: "917210995999",
  email: "info@agroya1935.com",
  hours: "Mon – Sat · 9:30 AM – 6:30 PM IST",
  address: "Parwati Industrial Estate, Pune Satara Road, Pune – 411019, Maharashtra, India",
  logo: "https://customer-assets.emergentagent.com/job_agroya-refine/artifacts/z91jevik_arc%20logo%20hd.png",
};

export const STATS = [
  { value: "99.90%", label: "Purity Standard" },
  { value: "100%", label: "Transparency" },
  { value: "1000+", label: "Trusted Partners" },
  { value: "Eco", label: "Ethically Processed" },
];

export const VALUES = [
  "Integrity",
  "Transparency",
  "Innovation",
  "Customer First",
  "Sustainability",
  "Quality Excellence",
];

export const SERVICES = [
  {
    icon: "Gem",
    title: "Gold Refining",
    desc: "High purity refining of 24K gold using advanced electrolytic and chemical processes.",
  },
  {
    icon: "Coins",
    title: "Silver Refining",
    desc: "Industrial and bullion grade silver refining with consistent 999.9 purity outputs.",
  },
  {
    icon: "Recycle",
    title: "Precious Metal Recovery",
    desc: "Recovery from jewellery scrap and manufacturing residues.",
  },
  {
    icon: "Microscope",
    title: "Assaying & Purity Analysis",
    desc: "Accurate purity testing using XRF spectrometry and modern fire-assay laboratories.",
  },
  {
    icon: "Boxes",
    title: "Bullion Manufacturing",
    desc: "Precision-minted gold and silver bars with serialised assay certificates.",
  },
  {
    icon: "Handshake",
    title: "Precious Metal Consultation",
    desc: "Professional guidance for refining strategy, recovery yield and compliance.",
  },
];

export const WHY_CHOOSE = [
  "High Recovery Rates",
  "Transparent Process",
  "Fair Valuation",
  "Advanced Technology",
  "Experienced Team",
  "Fast Turnaround",
  "Competitive Pricing",
  "Secure Handling",
  "Quality Assurance",
  "Customer-Centric Approach",
];

export const PROCESS_STEPS = [
  { icon: "Inbox", title: "Collection", desc: "Secured logistics & sealed intake." },
  { icon: "TestTube", title: "Assaying", desc: "Sampling and purity baseline." },
  { icon: "Flame", title: "Melting", desc: "Controlled high-temperature melt." },
  { icon: "Atom", title: "Refining", desc: "Electrolytic & chemical separation." },
  { icon: "Beaker", title: "Purity Testing", desc: "XRF & fire-assay verification." },
  { icon: "ShieldCheck", title: "Quality Inspection", desc: "Multi-stage QC sign-off." },
  { icon: "Hammer", title: "Casting", desc: "Bar & minted product casting." },
  { icon: "Truck", title: "Delivery", desc: "Insured, fully traceable dispatch." },
];

export const INDUSTRIES = [
  "Jewellers",
  "Bullion Dealers",
  "Gold Traders",
  "Silver Traders",
  "Banks",
  "Financial Institutions",
  "Manufacturers",
  "Industrial Customers",
  "Recyclers",
  "Exporters",
];

export const INFRASTRUCTURE = [
  { title: "Modern Refinery", desc: "Climate-controlled refining bays with continuous monitoring." },
  { title: "Advanced Machinery", desc: "Latest electrolysis, induction and casting equipment." },
  { title: "Quality Laboratory", desc: "XRF, fire-assay and ICP-OES analytical instruments." },
  { title: "Secure Vault", desc: "Bank-grade dual-key vault with 24/7 surveillance." },
  { title: "Melting Facility", desc: "High-capacity precision melting & alloy correction." },
  { title: "Purification Unit", desc: "Multi-stage refining to 999.9+ purity." },
  { title: "Packaging Department", desc: "Tamper-evident packaging with assay seals." },
  { title: "Quality Control", desc: "Dedicated multi-stage QC and traceability." },
];

export const CERTIFICATIONS = [
  { code: "NABL", note: "Laboratory accreditation" },
  { code: "BIS", note: "Bureau of Indian Standards" },
  { code: "MSME", note: "MSME registered enterprise" },
  { code: "GST", note: "GST compliant" },
  { code: "IEC", note: "Import-Export Code" },
  { code: "PCB", note: "Pollution Control Compliance" },
  { code: "ISO", note: "ISO certification (in progress)" },
];

export const PRODUCTS = [
  { title: "Gold Bars", desc: "99.9 and 99.50 purity gold bars, 1g – 1kg, with assay certificate." },
  { title: "Silver Bars", desc: "999.0 fine silver bars in 10g to 1kg variants." },
  { title: "Custom Bullion", desc: "Branded private-label minting for institutional clients." },
  { title: "Minted Products", desc: "Premium minted coins & medallions with serial IDs." },
  { title: "Investment Bars", desc: "Vault-ready investment-grade bullion for portfolios." },
];

export const SUSTAINABILITY = [
  { title: "Responsible Sourcing", desc: "Strict KYC and origin verification for all intake." },
  { title: "Ethical Refining", desc: "Conflict-free, fully traceable refining workflows." },
  { title: "Waste Reduction", desc: "Closed-loop processes minimise refining byproducts." },
  { title: "Environmental Care", desc: "Compliant treatment & discharge for all effluents." },
  { title: "Energy Efficiency", desc: "Heat-recovery induction systems lower carbon load." },
  { title: "Green Initiatives", desc: "Solar-assisted facility operations under expansion." },
];

export const TESTIMONIALS = [
  {
    quote:
      "Agroya combines old-world trust with modern transparency. Their assay reports are now our benchmark.",
    name: "Rohit Mehta",
    role: "Director, Mehta Jewellers · Pune",
  },
  {
    quote:
      "Recovery yield and turnaround have been consistently superior. A genuinely professional refinery.",
    name: "Anjali Kapoor",
    role: "Head of Procurement, Kapoor Bullion · Mumbai",
  },
  {
    quote:
      "Their lab-grade purity testing and secure logistics gave our institutional desk full confidence.",
    name: "Sanjay Iyer",
    role: "Treasury Lead, Indus Capital · Bengaluru",
  },
  {
    quote:
      "From scrap collection to certified bars — every step felt transparent. Exactly what we needed.",
    name: "Pooja Shah",
    role: "Founder, Aurum Designs · Ahmedabad",
  },
];

export const FAQS = [
  {
    q: "How does the refining process work?",
    a: "Material is sealed at collection, assayed to establish baseline purity, melted, then refined via electrolytic and chemical processes. Purity is verified by XRF and fire-assay before casting, QC and dispatch.",
  },
  {
    q: "How long does refining take?",
    a: "Standard turnaround is 24–72 hours depending on metal type, quantity and the target purity. Express options are available for institutional clients.",
  },
  {
    q: "How is purity determined?",
    a: "We use multi-method verification — XRF spectrometry, fire-assay and ICP-OES — to certify purity to 99.90 / 99.50 for gold and 999.0 for silver.",
  },
  {
    q: "Do you provide assay reports?",
    a: "Yes. Every batch is delivered with a serialised, tamper-evident assay certificate that is independently verifiable.",
  },
  {
    q: "Is my material secure?",
    a: "Material is sealed at intake, tracked end-to-end, processed in CCTV-monitored bays and stored in a bank-grade dual-key vault. Insurance coverage applies throughout.",
  },
  {
    q: "Do you handle small quantities?",
    a: "Yes — we serve jewellers, traders and institutional clients alike, with no minimum tonnage for assayed refining services.",
  },
];

export const FOOTER_LINKS = {
  Company: [
    { label: "About", href: "/#about" },
    { label: "Services", href: "/#services" },
    { label: "Products", href: "/#products" },
    { label: "Quality", href: "/#quality" },
  ],
  Resources: [
    { label: "Careers", href: "/careers" },
    { label: "Blog", href: "/blog" },
    { label: "FAQs", href: "/#faq" },
    { label: "Contact", href: "/#contact" },
  ],
  Legal: [
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms & Conditions", href: "/terms" },
  ],
};
